import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPdfByCaseId, fetchPdfByAttachmentId } from "./pdfThunk";

interface PdfState {
  togglePdf: boolean;
  pdfUrl: string | null;
  loading: boolean;
  error: any;
  attachmentPdfUrl: string | null;
  attachmentLoading: boolean;
  attachmentError: any;
}

const initialState: PdfState = {
  togglePdf: false,
  pdfUrl: null,
  loading: false,
  error: null,
  attachmentPdfUrl: null,
  attachmentLoading: false,
  attachmentError: null,
};

export const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    togglePdf: (state) => {
      state.togglePdf = !state.togglePdf;
    },
    setPdf: (state, action: PayloadAction<boolean>) => {
      state.togglePdf = action.payload;
    },
    clearPdf(state) {
      state.pdfUrl && URL.revokeObjectURL(state.pdfUrl);
      state.pdfUrl = null;
    },
    clearAttachmentPdf(state) {
      state.attachmentPdfUrl && URL.revokeObjectURL(state.attachmentPdfUrl);
      state.attachmentPdfUrl = null;
    },
    setLoadingStateToTrue: (state) => {
      state.loading = true;
    },
    setLoadingStateToFalse: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPdfByCaseId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPdfByCaseId.fulfilled, (state, action) => {
        state.loading = false;
        state.pdfUrl = action.payload;
      })
      .addCase(fetchPdfByCaseId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchPdfByAttachmentId.pending, (state) => {
        state.attachmentLoading = true;
        state.attachmentError = null;
      })
      .addCase(fetchPdfByAttachmentId.fulfilled, (state, action) => {
        state.attachmentLoading = false;
        state.attachmentPdfUrl = action.payload;
      })
      .addCase(fetchPdfByAttachmentId.rejected, (state, action) => {
        state.attachmentLoading = false;
        state.attachmentError = action.payload as string;
      });
  },
});

export const {
  togglePdf,
  setPdf,
  clearPdf,
  clearAttachmentPdf,
  setLoadingStateToTrue,
  setLoadingStateToFalse,
} = pdfSlice.actions;

export const selectTogglePdf = (state: { pdf: PdfState }) =>
  state.pdf.togglePdf;

export const selectAttachmentPdfUrl = (state: { pdf: PdfState }) =>
  state.pdf.attachmentPdfUrl;

export const selectAttachmentLoading = (state: { pdf: PdfState }) =>
  state.pdf.attachmentLoading;

export const selectAttachmentError = (state: { pdf: PdfState }) =>
  state.pdf.attachmentError;

export default pdfSlice.reducer;
